export default {
  p2p: 'P2P',
  trade: 'Trades',
  bank: 'Banco',
  swap: 'Canjear',
  buy: 'Compras',
  forex: 'Forex', // TODO: translate?
  filterBy: 'Filtrar por',
  older: 'Antiguo',
  recent: 'Reciente',
  from: 'Desde',
  to: 'Para',
  sent: 'Enviado',
  received: 'Recibido',
  p2pEmptyMsn: 'La actividad confirmada de Bitcash P2P se reflejará aquí.',
  tradeEmptyMsn: 'Las transacciones confirmadas se verán reflejadas aquí',
  paymentsEmptyMsn: 'Las transferencias confirmadas se verán reflejadas aquí.',
  fee: 'tarifa',
  deposit: 'depósito',
  transfer: 'transferencia',
  'There is currently no buy history': 'Actualmente no hay historial de compras',
  'There is currently no sell history': 'Actualmente no hay historial de ventas',
  'There is currently no history': 'Actualmente no hay historial',
  'There is currently no send history': 'Actualmente no hay historial de envíos',
  'There is currently no receipt history': 'Actualmente no hay historial de recibos',
  cancel_approved: 'Cancelación aprobada',
  cancel_requested: 'Cancelación solicitada',
}
